import { render, staticRenderFns } from "./CompatibleWithList.vue?vue&type=template&id=59c746a0&scoped=true&"
import script from "./CompatibleWithList.vue?vue&type=script&lang=js&"
export * from "./CompatibleWithList.vue?vue&type=script&lang=js&"
import style0 from "./CompatibleWithList.vue?vue&type=style&index=0&id=59c746a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c746a0",
  null
  
)

export default component.exports